import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureSolidDashKpiProviders } from "./categoryChartData.types";
import { getKpisForProvidersWithCategoryChart } from "../../Components/opendata";
import { getLostSuppliedVolumnPercent } from "./fetchFigureLostSuppliedVolumePercentChartData";
import { EMPTY_ARRAY, extractComparionChartData, getFigureAndSolidDashGraph } from "../misc";

import _ from "lodash";

// export const fetchFigureLostSuppliedVolumePercentComparisonChartData: CategoryChartQueryFn = async ({
//     categoryChart,
//     providers,
//     kpis,
//     category
// }: CategoryChartQueryParam): Promise<CategoryChartData> => {
//     const provider = providers?.[0];
//     const kpi = kpis?.[0];
//     if (!provider || !categoryChart || kpi == null) return null;

//     const groupByYearKpiReportResults = _.groupBy(kpiReportResults, d => d.year);
//     const unit: Unit = "%";

//     let years = _.orderBy(_.uniq(kpiReportResults?.map(d => d.year) ?? []) ?? [], d => d, "asc");
//     const providerValues = _.flattenDeep(
//         providers?.map(
//             provider =>
//                 years
//                     ?.map(year => {
//                         const reports = groupByYearKpiReportResults[year];
//                         const providerValue = getLostSuppliedVolumnPercent(provider, kpis, reports);
//                         const providerValueStatus = reports?.find(d => d?.provider?.tid === provider?.tid)?.valueStatus;

//                         return {
//                             year: year,
//                             providerTid: provider?.tid,
//                             providerValue,
//                             providerValueStatus
//                         };
//                     })
//                     ?.filter(
//                         d => (d?.providerValue != null || d?.providerValueStatus != null) && d?.providerTid != null
//                     ) ?? []
//         )
//     );

//     const providerTidToProviderValue = _.groupBy(providerValues, d => d.providerTid);

//     years = _.uniq(providerValues?.map(d => d.year)?.filter(d => d != null) ?? []);

//     const glLatestYear = years?.[years.length - 1];
//     const glPreviousYear = years?.[years.length - 2];

//     const { displayTitle, figureHeader, figureFooter } = categoryChart;

//     // kpi report results for the provider
//     const providerTidToYearData =
//         providers
//             ?.map(provider => {
//                 const yearAsc = _.orderBy(providerTidToProviderValue?.[provider?.tid] ?? [], d => d.year, "asc");
//                 const yearToResults = _.keyBy(yearAsc, d => d.year);
//                 return {
//                     providerId: provider?.tid,
//                     yearAsc,
//                     yearToResults
//                 };
//             })
//             ?.reduce<
//                 Record<
//                     string,
//                     {
//                         yearAsc: {
//                             year: number;
//                             providerTid: number;
//                             providerValue: number;
//                             providerValueStatus: ValueStatus;
//                         }[];
//                         yearToResults: Record<
//                             number,
//                             {
//                                 year: number;
//                                 providerTid: number;
//                                 providerValue: number;
//                                 providerValueStatus: ValueStatus;
//                             }
//                         >;
//                         indicatorTitle: string;
//                     }
//                 >
//             >((prev, { providerId, yearAsc, yearToResults }) => {
//                 prev[providerId] = {
//                     yearAsc,
//                     yearToResults: yearToResults as Record<
//                         number,
//                         {
//                             year: number;
//                             providerTid: number;
//                             providerValue: number;
//                             providerValueStatus: ValueStatus;
//                         }
//                     >,
//                     indicatorTitle: "Economic real rate of return"
//                 };

//                 return prev;
//             }, {}) ?? {};

//     // figures
//     const figures =
//         providers
//             ?.map((provider, providerIndex) => {
//                 // if (!providerTidToYearData?.[provider?.tid]) return null;
//                 const providerExist = providerTidToYearData?.[provider?.tid] != null;
//                 const { yearToResults } = providerTidToYearData?.[provider?.tid] ?? {};

//                 const latestYearResult = yearToResults?.[glLatestYear];
//                 const previousYearResult = yearToResults?.[glPreviousYear];

//                 const { providerValue: previousYearValue } = previousYearResult ?? {};
//                 const { providerValue: latestYearValue, providerValueStatus: latestYearValueStatus } =
//                     latestYearResult ?? {};

//                 // if data does not exist, return NA/ND view
//                 if (!providerExist || latestYearValue == null) {
//                     const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//                         ...providerTitleStartEndDiv,
//                         year: glLatestYear,
//                         value: null,
//                         deltaString: null,
//                         providerName: provider.name
//                     });

//                     const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//                         ...providerTitleStartEndDiv,
//                         year: glLatestYear,
//                         value: null,
//                         deltaString: null,
//                         providerName: provider.name
//                     });

//                     return [
//                         {
//                             kpiCode: "",
//                             schemeType: "",
//                             unit: null,
//                             header:
//                                 !figureHeader || figureHeader.processed.trim() === ""
//                                     ? null
//                                     : {
//                                           processed: figureHeaderProcessed,
//                                           value: figureHeaderProcessed,
//                                           format: figureHeaderProcessed
//                                       },
//                             footer:
//                                 !figureFooter || figureFooter.processed.trim() === ""
//                                     ? null
//                                     : {
//                                           processed: figureFooterProcessed,
//                                           value: figureFooterProcessed,
//                                           format: figureFooterProcessed
//                                       },
//                             value:
//                                 latestYearValueStatus != null
//                                     ? latestYearValueStatus
//                                     : !providerExist
//                                     ? NA
//                                     : previousYearValue != null && latestYearValue == null
//                                     ? MD
//                                     : NA,
//                             decimals: 0
//                         }
//                     ];
//                 }

//                 const delta = deltaValue(previousYearValue, latestYearValue);

//                 const deltaString = figureDeltaString(delta, category, providerIndex);
//                 const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//                     ...providerTitleStartEndDiv,
//                     year: `${glLatestYear}`,
//                     value: latestYearValue,
//                     deltaString,
//                     providerName: provider.name
//                 });

//                 const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//                     ...providerTitleStartEndDiv,
//                     year: `${glLatestYear}`,
//                     value: latestYearValue,
//                     deltaString,
//                     providerName: provider.name
//                 });

//                 return [
//                     {
//                         kpiCode: "",
//                         schemeType: "",
//                         unit: unit,
//                         header:
//                             !figureHeader || figureHeader.processed.trim() === ""
//                                 ? null
//                                 : {
//                                       processed: figureHeaderProcessed,
//                                       value: figureHeaderProcessed,
//                                       format: figureHeaderProcessed
//                                   },
//                         footer:
//                             !figureFooter || figureFooter.processed.trim() === ""
//                                 ? null
//                                 : {
//                                       processed: figureFooterProcessed,
//                                       value: figureFooterProcessed,
//                                       format: figureFooterProcessed
//                                   },
//                         value: roundValue(latestYearValue, unit).value,
//                         decimals: roundValue(latestYearValue, unit).decimals
//                     }
//                 ];
//             })
//             ?.filter(d => d != null) ?? [];

//     // kpi report results for the provider
//     const ret: FigureKpiProviders = {
//         title: displayTitle,
//         waterProviders: providers,
//         figures: figures,
//         footer: null
//     };

//     return ret;
// };

export const fetchFigureLostSuppliedVolumePercentComparisonChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProviders> => {
    if (!metadata || !providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0)
        return null;
    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, providers, true, categoryChart);

    const { displayTitle, visType } = categoryChart;
    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const volumeLossKpi = kpis?.[0]?.[0];
    const totalKpis = kpis.filter((__, index) => index > 0).map(d => d?.[0]);

    if (!volumeLossKpi || !totalKpis) return null;

    const totalKpiMap = totalKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const years = _.uniq(
        _.flattenDeep(
            _.values(_.groupBy(kpiReportResults, d => d?.provider?.tid)).map(results => {
                const years = _.orderBy(_.uniq(results.map(d => d.year)), d => d, "asc") ?? (EMPTY_ARRAY as number[]);
                const yearsToResults = _.groupBy(results, d => d.year);
                const startYear = years.find(
                    year =>
                        yearsToResults?.[year]?.find(res => res.kpiCode === volumeLossKpi && res.value != null) &&
                        yearsToResults?.[year]?.filter(res => totalKpiMap[res.kpiCode] === 1 && res.value != null)
                            ?.length > 0
                );

                return startYear == null ? [] : years.filter(y => y >= startYear);
            })
        )
    );

    // const years = _.orderBy(_.uniq(kpiReportResults.map(d => d.year)), d => d, "asc") ?? EMPTY_ARRAY;

    const _chartData = providers.map((provider, providerIndex) => {
        return {
            connectionSizeCategory: provider?.connectionSizeCategory,
            data: getFigureAndSolidDashGraph(
                metadata,
                provider,
                kpiReportResults,
                kpis,
                categoryChart,
                category,
                "%",
                getLostSuppliedVolumnPercent,
                years,
                providerIndex
            )
        };

        // return getFigureAndGraphForOperatingSurplusRatio(
        //     kpiReportResults,
        //     provider,
        //     kpis,
        //     categoryChart,
        //     category,
        //     years
        // );
    });

    if (!_chartData || _chartData?.length === 0) return null;

    const {
        years: displayedYears,
        displayedAverageData,
        displayedLinesData,
        header,
        footer,
        measure,
        latestYear,
        unit,
        figures,
        providerMedianAnnotations,
        providerMedianSeriesNames
    } = extractComparionChartData(categoryChart, _chartData);

    // const chartData = _chartData?.map(d => d.data);

    // const figures = chartData.map(d => d.figure);

    // const providerMedianData = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianData;
    // });

    // const providerMedianSeriesNames = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianSeriesName;
    // });

    // const providerMedianAnnotations = _.uniqBy(_chartData, d => d.connectionSizeCategory).map(d => {
    //     return d?.data?.graph?.providerMedianAnnotation;
    // });

    return {
        title: displayTitle,
        kpiCode: null,
        schemeType: kpis?.[0]?.[1],
        waterProviders: providers,
        unit,
        year: latestYear,
        figures: !(visType === "figureWithSolidDashLine") ? null : figures,
        graph:
            visType === "figure"
                ? null
                : {
                      measure,
                      header,
                      footer,
                      years: displayedYears,
                      // largeProviderAverageData: chartData?.[0]?.graph?.largeProviderAverageData,
                      // largeProviderAverageSeriesName: chartData?.[0]?.graph?.largeProviderAverageSeriesName,

                      providerMedianData: displayedAverageData,
                      providerMedianSeriesNames,
                      providerMedianAnnotations,

                      linesData: displayedLinesData,
                      linesDataSeriesName: providers.map(provider => provider.name)
                      // chartData?.map(d => d?.graph?.lineDataSeriesName).filter(d => d != null) ?? EMPTY_ARRAY
                  }
    };
};
